export default __webpack_public_path__ + "static/media/footer-background-responsive.fc93f9a4.svg";